import { Link } from "react-router-dom";
import { useTheme } from "@/contexts/ThemeContext";

export const Footer = () => {
  const { theme } = useTheme();
  
  // Function to manually scroll to top when links are clicked
  const handleLinkClick = () => {
    // Force immediate scroll to top
    window.scrollTo(0, 0);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    
    // Also do it after a small delay to ensure it works
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 100);
  };

  return (
    <footer id="footer" className={`border-t ${theme === 'dark' ? 'border-gray-800/30' : 'border-gray-300/30'} py-12 mt-auto relative z-10`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and tagline */}
          <div>
            <Link to="/" className="flex items-center gap-2 group relative z-10">
              <img
                src="/docgen-logo.png"
                alt="DocGen Logo"
                className="h-8 w-8"
              />
              <span className={`font-semibold text-lg ${theme === 'dark' ? 'text-white' : 'text-gray-800'}`}>
                DocGen
              </span>
            </Link>
            <p className={`${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'} mt-3 text-sm`}>
              Documentation that writes itself
            </p>
          </div>
          
          {/* Contact links */}
          <div className="relative z-10">
            <h3 className={`${theme === 'dark' ? 'text-white' : 'text-gray-800'} font-medium mb-4`}>Contact</h3>
            <ul className="space-y-2">
            {/* <li>
                <a href="mailto:aniket@docgen.dev" className="text-gray-400 hover:text-primary text-sm transition-colors duration-200 block py-1">
                  Send us an email
                </a>
              </li> */}
              <li>
                <a 
                  href="https://cal.com/aniket-docgen/30min" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={`${theme === 'dark' ? 'text-gray-400 hover:text-primary' : 'text-gray-600 hover:text-primary-light'} text-sm transition-colors duration-200 block py-1`}
                >
                  Book a demo
                </a>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className={`${theme === 'dark' ? 'text-gray-400 hover:text-primary' : 'text-gray-600 hover:text-primary-light'} text-sm transition-colors duration-200 block py-1`}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Company links */}
          <div className="relative z-10">
            <h3 className={`${theme === 'dark' ? 'text-white' : 'text-gray-800'} font-medium mb-4`}>Company</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className={`${theme === 'dark' ? 'text-gray-400 hover:text-primary' : 'text-gray-600 hover:text-primary-light'} text-sm transition-colors duration-200 block py-1`}
                >
                  Home
                </Link>
              </li>
              {/* <li>
                <Link 
                  to="/pricing" 
                  className="text-gray-400 hover:text-primary text-sm transition-colors duration-200 block py-1"
                  onClick={handleLinkClick}
                >
                  Pricing
                </Link>
              </li> */}
              <li>
                <Link 
                  to="/privacy-policy" 
                  className={`${theme === 'dark' ? 'text-gray-400 hover:text-primary' : 'text-gray-600 hover:text-primary-light'} text-sm transition-colors duration-200 block py-1`}
                  onClick={handleLinkClick}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-use" 
                  className={`${theme === 'dark' ? 'text-gray-400 hover:text-primary' : 'text-gray-600 hover:text-primary-light'} text-sm transition-colors duration-200 block py-1`}
                  onClick={handleLinkClick}
                >
                  Terms of Use
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className={`border-t ${theme === 'dark' ? 'border-gray-800/30' : 'border-gray-300/30'} mt-8 pt-8 text-center`}>
          <p className={`${theme === 'dark' ? 'text-gray-500' : 'text-gray-500'} text-sm`}>
            © {new Date().getFullYear()} DocGen. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}; 